import { CustomsInvoiceMapper } from './CustomsInvoiceMapper.js';

class DraftCustomsInvoicesRepository {
  constructor(apiClient) {
    this.apiClient = apiClient;
  }
  get(id) {
    return this.apiClient.get(`v1/draft-customs-invoices/${id}`).then(response => CustomsInvoiceMapper.createModelFromResponse(response.data));
  }
  create(invoice) {
    return this.apiClient.post('v1/draft-customs-invoices', CustomsInvoiceMapper.createApiPayload(invoice)).then(response => CustomsInvoiceMapper.createModelFromResponse(response.data));
  }
  update(invoice) {
    return this.apiClient.put(`v1/draft-customs-invoices/${invoice.id}`, CustomsInvoiceMapper.createApiPayload(invoice)).then(response => CustomsInvoiceMapper.createModelFromResponse(response.data));
  }
}

export { DraftCustomsInvoicesRepository };
//# sourceMappingURL=DraftCustomsInvoicesRepository.js.map
